import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const OklchAura = definePreset(Aura, {
    primitive: {
        borderRadius: {
            none: '0',
            xs: '0.125rem',
            sm: '0.25rem',
            md: '0.375rem',
            lg: '0.5rem',
            xl: '0.75rem',
        },
        red: {
            50: 'var(--color-red-50)',
            100: 'var(--color-red-100)',
            200: 'var(--color-red-200)',
            300: 'var(--color-red-300)',
            400: 'var(--color-red-400)',
            500: 'var(--color-red-500)',
            600: 'oklch(0.5661 0.189 27.68)',
            700: 'var(--color-red-700)',
            800: 'var(--color-red-800)',
            900: 'var(--color-red-900)',
            950: 'var(--color-red-950)',
        },
        orange: {
            50: 'var(--color-orange-50)',
            100: 'var(--color-orange-100)',
            200: 'var(--color-orange-200)',
            300: 'var(--color-orange-300)',
            400: 'var(--color-orange-400)',
            500: 'var(--color-orange-500)',
            600: 'var(--color-orange-600)',
            700: 'var(--color-orange-700)',
            800: 'var(--color-orange-800)',
            900: 'var(--color-orange-900)',
            950: 'var(--color-orange-950)',
        },
        amber: {
            50: 'var(--color-amber-50)',
            100: 'var(--color-amber-100)',
            200: 'var(--color-amber-200)',
            300: 'var(--color-amber-300)',
            400: 'var(--color-amber-400)',
            500: 'var(--color-amber-500)',
            600: 'var(--color-amber-600)',
            700: 'var(--color-amber-700)',
            800: 'var(--color-amber-800)',
            900: 'var(--color-amber-900)',
            950: 'var(--color-amber-950)',
        },
        yellow: {
            50: 'var(--color-yellow-50)',
            100: 'var(--color-yellow-100)',
            200: 'var(--color-yellow-200)',
            300: 'var(--color-yellow-300)',
            400: 'var(--color-yellow-400)',
            500: 'var(--color-yellow-500)',
            600: 'var(--color-yellow-600)',
            700: 'var(--color-yellow-700)',
            800: 'var(--color-yellow-800)',
            900: 'var(--color-yellow-900)',
            950: 'var(--color-yellow-950)',
        },
        lime: {
            50: 'var(--color-lime-50)',
            100: 'var(--color-lime-100)',
            200: 'var(--color-lime-200)',
            300: 'var(--color-lime-300)',
            400: 'var(--color-lime-400)',
            500: 'var(--color-lime-500)',
            600: 'var(--color-lime-600)',
            700: 'var(--color-lime-700)',
            800: 'var(--color-lime-800)',
            900: 'var(--color-lime-900)',
            950: 'var(--color-lime-950)',
        },
        green: {
            50: 'var(--color-green-50)',
            100: 'var(--color-green-100)',
            200: 'var(--color-green-200)',
            300: 'var(--color-green-300)',
            400: 'var(--color-green-400)',
            500: 'var(--color-green-500)',
            600: 'var(--color-green-600)',
            700: 'var(--color-green-700)',
            800: 'var(--color-green-800)',
            900: 'var(--color-green-900)',
            950: 'var(--color-green-950)',
        },
        emerald: {
            50: 'var(--color-emerald-50)',
            100: 'var(--color-emerald-100)',
            200: 'var(--color-emerald-200)',
            300: 'var(--color-emerald-300)',
            400: 'var(--color-emerald-400)',
            500: 'var(--color-emerald-500)',
            600: 'var(--color-emerald-600)',
            700: 'var(--color-emerald-700)',
            800: 'var(--color-emerald-800)',
            900: 'var(--color-emerald-900)',
            950: 'var(--color-emerald-950)',
        },
        teal: {
            50: 'var(--color-teal-50)',
            100: 'var(--color-teal-100)',
            200: 'var(--color-teal-200)',
            300: 'var(--color-teal-300)',
            400: 'var(--color-teal-400)',
            500: 'var(--color-teal-500)',
            600: 'var(--color-teal-600)',
            700: 'var(--color-teal-700)',
            800: 'var(--color-teal-800)',
            900: 'var(--color-teal-900)',
            950: 'var(--color-teal-950)',
        },
        cyan: {
            50: 'var(--color-cyan-50)',
            100: 'var(--color-cyan-100)',
            200: 'var(--color-cyan-200)',
            300: 'var(--color-cyan-300)',
            400: 'var(--color-cyan-400)',
            500: 'var(--color-cyan-500)',
            600: 'var(--color-cyan-600)',
            700: 'var(--color-cyan-700)',
            800: 'var(--color-cyan-800)',
            900: 'var(--color-cyan-900)',
            950: 'var(--color-cyan-950)',
        },
        sky: {
            50: 'var(--color-sky-50)',
            100: 'var(--color-sky-100)',
            200: 'var(--color-sky-200)',
            300: 'var(--color-sky-300)',
            400: 'var(--color-sky-400)',
            500: 'var(--color-sky-500)',
            600: 'var(--color-sky-600)',
            700: 'var(--color-sky-700)',
            800: 'var(--color-sky-800)',
            900: 'var(--color-sky-900)',
            950: 'var(--color-sky-950)',
        },
        blue: {
            50: 'var(--color-blue-50)',
            100: 'var(--color-blue-100)',
            200: 'var(--color-blue-200)',
            300: 'var(--color-blue-300)',
            400: 'var(--color-blue-400)',
            500: 'var(--color-blue-500)',
            600: 'var(--color-blue-600)',
            700: 'var(--color-blue-700)',
            800: 'var(--color-blue-800)',
            900: 'var(--color-blue-900)',
            950: 'var(--color-blue-950)',
        },
        indigo: {
            50: 'var(--color-indigo-50)',
            100: 'var(--color-indigo-100)',
            200: 'var(--color-indigo-200)',
            300: 'var(--color-indigo-300)',
            400: 'var(--color-indigo-400)',
            500: 'var(--color-indigo-500)',
            600: 'var(--color-indigo-600)',
            700: 'var(--color-indigo-700)',
            800: 'var(--color-indigo-800)',
            900: 'var(--color-indigo-900)',
            950: 'var(--color-indigo-950)',
        },
        violet: {
            50: 'var(--color-violet-50)',
            100: 'var(--color-violet-100)',
            200: 'var(--color-violet-200)',
            300: 'var(--color-violet-300)',
            400: 'var(--color-violet-400)',
            500: 'var(--color-violet-500)',
            600: 'var(--color-violet-600)',
            700: 'var(--color-violet-700)',
            800: 'var(--color-violet-800)',
            900: 'var(--color-violet-900)',
            950: 'var(--color-violet-950)',
        },
        purple: {
            50: 'var(--color-purple-50)',
            100: 'var(--color-purple-100)',
            200: 'var(--color-purple-200)',
            300: 'var(--color-purple-300)',
            400: 'var(--color-purple-400)',
            500: 'var(--color-purple-500)',
            600: 'var(--color-purple-600)',
            700: 'var(--color-purple-700)',
            800: 'var(--color-purple-800)',
            900: 'var(--color-purple-900)',
            950: 'var(--color-purple-950)',
        },
        fuchsia: {
            50: 'var(--color-fuchsia-50)',
            100: 'var(--color-fuchsia-100)',
            200: 'var(--color-fuchsia-200)',
            300: 'var(--color-fuchsia-300)',
            400: 'var(--color-fuchsia-400)',
            500: 'var(--color-fuchsia-500)',
            600: 'var(--color-fuchsia-600)',
            700: 'var(--color-fuchsia-700)',
            800: 'var(--color-fuchsia-800)',
            900: 'var(--color-fuchsia-900)',
            950: 'var(--color-fuchsia-950)',
        },
        pink: {
            50: 'var(--color-pink-50)',
            100: 'var(--color-pink-100)',
            200: 'var(--color-pink-200)',
            300: 'var(--color-pink-300)',
            400: 'var(--color-pink-400)',
            500: 'var(--color-pink-500)',
            600: 'var(--color-pink-600)',
            700: 'var(--color-pink-700)',
            800: 'var(--color-pink-800)',
            900: 'var(--color-pink-900)',
            950: 'var(--color-pink-950)',
        },
        rose: {
            50: 'var(--color-rose-50)',
            100: 'var(--color-rose-100)',
            200: 'var(--color-rose-200)',
            300: 'var(--color-rose-300)',
            400: 'var(--color-rose-400)',
            500: 'var(--color-rose-500)',
            600: 'var(--color-rose-600)',
            700: 'var(--color-rose-700)',
            800: 'var(--color-rose-800)',
            900: 'var(--color-rose-900)',
            950: 'var(--color-rose-950)',
        },
        slate: {
            50: 'var(--color-slate-50)',
            100: 'var(--color-slate-100)',
            200: 'var(--color-slate-200)',
            300: 'var(--color-slate-300)',
            400: 'var(--color-slate-400)',
            500: 'var(--color-slate-500)',
            600: 'var(--color-slate-600)',
            700: 'var(--color-slate-700)',
            800: 'var(--color-slate-800)',
            900: 'var(--color-slate-900)',
            950: 'var(--color-slate-950)',
        },
        gray: {
            50: 'var(--color-gray-50)',
            100: 'var(--color-gray-100)',
            200: 'var(--color-gray-200)',
            300: 'var(--color-gray-300)',
            400: 'var(--color-gray-400)',
            500: 'var(--color-gray-500)',
            600: 'var(--color-gray-600)',
            700: 'var(--color-gray-700)',
            800: 'var(--color-gray-800)',
            900: 'var(--color-gray-900)',
            950: 'var(--color-gray-950)',
        },
        zinc: {
            50: 'var(--color-zinc-50)',
            100: 'var(--color-zinc-100)',
            200: 'var(--color-zinc-200)',
            300: 'var(--color-zinc-300)',
            400: 'var(--color-zinc-400)',
            500: 'var(--color-zinc-500)',
            600: 'var(--color-zinc-600)',
            700: 'var(--color-zinc-700)',
            800: 'var(--color-zinc-800)',
            900: 'var(--color-zinc-900)',
            950: 'var(--color-zinc-950)',
        },
        neutral: {
            50: 'var(--color-neutral-50)',
            100: 'var(--color-neutral-100)',
            200: 'var(--color-neutral-200)',
            300: 'var(--color-neutral-300)',
            400: 'var(--color-neutral-400)',
            500: 'var(--color-neutral-500)',
            600: 'var(--color-neutral-600)',
            700: 'var(--color-neutral-700)',
            800: 'var(--color-neutral-800)',
            900: 'var(--color-neutral-900)',
            950: 'var(--color-neutral-950)',
        },
        stone: {
            50: 'oklch(98.5% 0.003 115)',
            100: 'oklch(97% 0.004 115)',
            200: 'oklch(93.3% 0.009 68)',
            300: 'oklch(86.9% 0.015 66)',
            400: 'oklch(71.1% 0.025 66)',
            500: 'oklch(55.8% 0.031 68)',
            600: 'oklch(44.9% 0.027 83)',
            700: 'oklch(37.8% 0.024 76)',
            800: 'oklch(27.2% 0.018 44)',
            900: 'oklch(22% 0.015 65)',
            950: 'oklch(15% 0.011 59)',
        }
    },
    semantic: {
        overlay: {
            select: {
                shadow: '0 4px 6px -1px oklch(0% 0 0 / 10%), 0 2px 4px -2px oklch(0% 0 0 / 10%)',
            },
            popover: {
                shadow: '0 4px 6px -1px oklch(0% 0 0 / 10%), 0 2px 4px -2px oklch(0% 0 0 / 10%)',
            },
            modal: {
                shadow: '0 20px 25px -5px oklch(0% 0 0 / 10%), 0 8px 10px -6px oklch(0% 0 0 / 10%)',
            },
            navigation: {
                shadow: '0 4px 6px -1px oklch(0% 0 0 / 10%), 0 2px 4px -2px oklch(0% 0 0 / 10%)',
            },
        },
        colorScheme: {
            dark: {
                highlight: {
                    background: 'color-mix(in oklab, {primary.400} 16%, transparent)',
                    focusBackground: 'color-mix(in oklab, {primary.400} 24%, transparent)',
                    color: 'oklch(100% 0 0 / 87%)',
                    focusColor: 'oklch(100% 0 0 / 87%)',
                },
                mask: {
                    background: 'oklch(0% 0 0 / 60%)',
                },
                formField: {
                    shadow: '0 0 oklch(0% 0 0 / 0%), 0 0 oklch(0% 0 0 / 0%), 0 1px 2px 0 oklch(0.18 0.0101 285.36 / 5%)',
                },
            },
        },
    },
    components: {
        button: {
            root: {
                raisedShadow: '0 3px 1px -2px oklch(0% 0 0 / 20%), 0 2px 2px 0 oklch(0% 0 0 / 14%), 0 1px 5px 0 oklch(0% 0 0 / 12%)',
            },
            colorScheme: {
                light: {
                    outlined: {
                        primary: {
                            color: '{primary.700}',
                        },
                    },
                    root: {
                        danger: {
                            background: '{red.600}',
                        },
                    },
                    text: {
                        danger: {
                            color: '{red.600}',
                        },
                    },
                },
                dark: {
                    outlined: {
                        primary: {
                            hoverBackground: 'color-mix(in oklab, {primary.color} 4%, transparent)',
                            activeBackground: 'color-mix(in oklab, {primary.color} 16%, transparent)',
                        },
                        secondary: {
                            hoverBackground: 'oklch(100% 0 0 / 4%)',
                            activeBackground: 'oklch(100% 0 0 / 16%)',
                        },
                        success: {
                            hoverBackground: 'color-mix(in oklab, {green.400} 4%, transparent)',
                            activeBackground: 'color-mix(in oklab, {green.400} 16%, transparent)',
                        },
                        info: {
                            hoverBackground: 'color-mix(in oklab, {sky.400} 4%, transparent)',
                            activeBackground: 'color-mix(in oklab, {sky.400} 16%, transparent)',
                        },
                        warn: {
                            hoverBackground: 'color-mix(in oklab, {orange.400} 4%, transparent)',
                            activeBackground: 'color-mix(in oklab, {orange.400} 16%, transparent)',
                        },
                        help: {
                            hoverBackground: 'color-mix(in oklab, {purple.400} 4%, transparent)',
                            activeBackground: 'color-mix(in oklab, {purple.400} 16%, transparent)',
                        },
                        danger: {
                            hoverBackground: 'color-mix(in oklab, {red.400} 4%, transparent)',
                            activeBackground: 'color-mix(in oklab, {red.400} 16%, transparent)',
                        },
                    },
                    text: {
                        primary: {
                            hoverBackground: 'color-mix(in oklab, {primary.color} 4%, transparent)',
                            activeBackground: 'color-mix(in oklab, {primary.color} 16%, transparent)',
                        },
                        success: {
                            hoverBackground: 'color-mix(in oklab, {green.400} 4%, transparent)',
                            activeBackground: 'color-mix(in oklab, {green.400} 16%, transparent)',
                        },
                        info: {
                            hoverBackground: 'color-mix(in oklab, {sky.400} 4%, transparent)',
                            activeBackground: 'color-mix(in oklab, {sky.400} 16%, transparent)',
                        },
                        warn: {
                            hoverBackground: 'color-mix(in oklab, {orange.400} 4%, transparent)',
                            activeBackground: 'color-mix(in oklab, {orange.400} 16%, transparent)',
                        },
                        help: {
                            hoverBackground: 'color-mix(in oklab, {purple.400} 4%, transparent)',
                            activeBackground: 'color-mix(in oklab, {purple.400} 16%, transparent)',
                        },
                        danger: {
                            hoverBackground: 'color-mix(in oklab, {red.400} 4%, transparent)',
                            activeBackground: 'color-mix(in oklab, {red.400} 16%, transparent)',
                        },
                    },
                },
            },
        },
        card: {
            root: {
                shadow: '0 1px 3px 0 oklch(0% 0 0 / 10%), 0 1px 2px -1px oklch(0% 0 0 / 10%)',
            },
        },
        dock: {
            root: {
                background: 'oklch(100% 0 0 / 10%)',
                borderColor: 'oklch(100% 0 0 / 20%)',
            },
        },
        drawer: {
            root: {
                borderColor: 'none',
            },
        },
        fileupload: {
            content: {
                padding: '0',
            },
        },
        galleria: {
            navButton: {
                background: 'oklch(100% 0 0 / 10%)',
                hoverBackground: 'oklch(100% 0 0 / 20%)',
            },
            caption: {
                background: 'oklch(0% 0 0 / 50%)',
            },
            insetIndicatorList: {
                background: 'oklch(0% 0 0 / 50%)',
            },
            insetIndicatorButton: {
                background: 'oklch(100% 0 0 / 40%)',
                hoverBackground: 'oklch(100% 0 0 / 60%)',
                activeBackground: 'oklch(100% 0 0 / 90%)',
            },
            closeButton: {
                background: 'oklch(100% 0 0 / 10%)',
                hoverBackground: 'oklch(100% 0 0 / 20%)',
            },
        },
        image: {
            toolbar: {
                background: 'oklch(100% 0 0 / 10%)',
                borderColor: 'oklch(100% 0 0 / 20%)',
            },
            action: {
                hoverBackground: 'oklch(100% 0 0 / 10%)',
            },
        },
        imagecompare: {
            handle: {
                background: 'oklch(100% 0 0 / 30%)',
                hoverBackground: 'oklch(100% 0 0 / 30%)',
                focusRing: {
                    color: 'oklch(100% 0 0 / 30%)',
                },
            },
        },
        inlinemessage: {
            colorScheme: {
                dark: {
                    info: {
                        background: 'color-mix(in oklab, {blue.500} 16%, transparent)',
                        borderColor: 'color-mix(in oklab, {blue.700} 36%, transparent)',
                        shadow: '0px 4px 8px 0px color-mix(in oklab, {blue.500} 4%, transparent)',
                    },
                    success: {
                        background: 'color-mix(in oklab, {green.500} 16%, transparent)',
                        borderColor: 'color-mix(in oklab, {green.700} 36%, transparent)',
                        shadow: '0px 4px 8px 0px color-mix(in oklab, {green.500} 4%, transparent)',
                    },
                    warn: {
                        background: 'color-mix(in oklab, {yellow.500} 16%, transparent)',
                        borderColor: 'color-mix(in oklab, {yellow.700} 36%, transparent)',
                        shadow: '0px 4px 8px 0px color-mix(in oklab, {yellow.500} 4%, transparent)',
                    },
                    error: {
                        background: 'color-mix(in oklab, {red.500} 16%, transparent)',
                        borderColor: 'color-mix(in oklab, {red.700} 36%, transparent)',
                        shadow: '0px 4px 8px 0px color-mix(in oklab, {red.500} 4%, transparent)',
                    },
                    secondary: {
                        shadow: '0px 4px 8px 0px color-mix(in oklab, {surface.500} 4%, transparent)',
                    },
                    contrast: {
                        shadow: '0px 4px 8px 0px color-mix(in oklab, {surface.950} 4%, transparent)',
                    },
                },
            },
        },
        inputtext: {
            root: {
                invalidPlaceholderColor: '{red.500}',
                invalidBorderColor: '{red.500}',
            },
        },
        message: {
            colorScheme: {
                light: {
                    warn: {
                        background: '{secondary.50}',
                        borderColor: 'transparent',
                        color: '{secondary.700}',
                    },
                },
                dark: {
                    info: {
                        background: 'color-mix(in oklab, {blue.500} 16%, transparent)',
                        borderColor: 'color-mix(in oklab, {blue.700} 36%, transparent)',
                        shadow: '0px 4px 8px 0px color-mix(in oklab, {blue.500} 4%, transparent)',
                        closeButton: {
                            hoverBackground: 'oklch(100% 0 0 / 5%)',
                        },
                    },
                    success: {
                        background: 'color-mix(in oklab, {green.500} 16%, transparent)',
                        borderColor: 'color-mix(in oklab, {green.700} 36%, transparent)',
                        shadow: '0px 4px 8px 0px color-mix(in oklab, {green.500} 4%, transparent)',
                        closeButton: {
                            hoverBackground: 'oklch(100% 0 0 / 5%)',
                        },
                    },
                    warn: {
                        background: 'color-mix(in oklab, {yellow.500} 16%, transparent)',
                        borderColor: 'color-mix(in oklab, {yellow.700} 36%, transparent)',
                        shadow: '0px 4px 8px 0px color-mix(in oklab, {yellow.500} 4%, transparent)',
                        closeButton: {
                            hoverBackground: 'oklch(100% 0 0 / 5%)',
                        },
                    },
                    error: {
                        background: 'color-mix(in oklab, {red.500} 16%, transparent)',
                        borderColor: 'color-mix(in oklab, {red.700} 36%, transparent)',
                        shadow: '0px 4px 8px 0px color-mix(in oklab, {red.500} 4%, transparent)',
                        closeButton: {
                            hoverBackground: 'oklch(100% 0 0 / 5%)',
                        },
                    },
                    secondary: {
                        shadow: '0px 4px 8px 0px color-mix(in oklab, {surface.500} 4%, transparent)',
                    },
                    contrast: {
                        shadow: '0px 4px 8px 0px color-mix(in oklab, {surface.950} 4%, transparent)',
                    },
                },
            },
        },
        ripple: {
            colorScheme: {
                dark: {
                    root: {
                        background: 'oklch(100% 0 0 / 30%)',
                    },
                },
            },
        },
        skeleton: {
            colorScheme: {
                dark: {
                    root: {
                        background: 'oklch(100% 0 0 / 6%)',
                        animationBackground: 'oklch(100% 0 0 / 4%)',
                    },
                },
            },
        },
        select: {
            root: {
                invalidPlaceholderColor: '{red.500}',
                invalidBorderColor: '{red.500}',
            },
        },
        slider: {
            handle: {
                content: {
                    shadow: '0px 0.5px 0px 0px oklch(0% 0 0 / 8%), 0px 1px 1px 0px oklch(0% 0 0 / 14%)',
                },
            },
        },
        splitbutton: {
            root: {
                raisedShadow: '0 3px 1px -2px oklch(0% 0 0 / 20%), 0 2px 2px 0 oklch(0% 0 0 / 14%), 0 1px 5px 0 oklch(0% 0 0 / 12%)',
            },
        },
        stepper: {
            stepNumber: {
                shadow: '0px 0.5px 0px 0px oklch(0% 0 0 / 6%), 0px 1px 1px 0px oklch(0% 0 0 / 12%)',
            },
        },
        steps: {
            itemNumber: {
                shadow: '0px 0.5px 0px 0px oklch(0% 0 0 / 6%), 0px 1px 1px 0px oklch(0% 0 0 / 12%)',
            },
        },
        
        tabs: {
            colorScheme: {
                dark: {
                    navButton: {
                        shadow: '0px 0px 10px 50px color-mix(in oklab, {content.background} 50%, transparent)',
                    },
                },
            },
        },
        panelmenu: {
            item: {
                focusBackground: 'oklch(100% 0 0 / 6%)',
                color: '{surface.500}',
                focusColor: '{surface.500}',
            },
            panel: {
                background: 'oklch(0.27 0 0)',
            },
        },
        tabview: {
            colorScheme: {
                dark: {
                    navButton: {
                        shadow: '0px 0px 10px 50px color-mix(in oklab, {content.background} 50%, transparent)',
                    },
                },
            },
        },
        tag: {
            colorScheme: {
                dark: {
                    primary: {
                        background: 'color-mix(in oklab, {primary.500} 16%, transparent)',
                    },
                    success: {
                        background: 'color-mix(in oklab, {green.500} 16%, transparent)',
                    },
                    info: {
                        background: 'color-mix(in oklab, {sky.500} 16%, transparent)',
                    },
                    warn: {
                        background: 'color-mix(in oklab, {orange.500} 16%, transparent)',
                    },
                    danger: {
                        background: 'color-mix(in oklab, {red.500} 16%, transparent)',
                    },
                },
                light: {
                    primary: {
                        background: '{primary.600}',
                        color: '#ffffff',
                    },
                    secondary: {
                        background: 'oklch(0.9741 0.0115 37.42)',
                        color: 'oklch(0.5808 0.1918 349.6)',
                    },
                },
            },
        },
        textarea: {
            root: {
                invalidPlaceholderColor: '{red.500}',
                invalidBorderColor: '{red.500}',
            },
        },
        timeline: {
            eventMarker: {
                content: {
                    insetShadow: '0px 0.5px 0px 0px oklch(0% 0 0 / 6%), 0px 1px 1px 0px oklch(0% 0 0 / 12%)',
                },
            },
        },
        toast: {
            colorScheme: {
                dark: {
                    info: {
                        background: 'color-mix(in oklab, {blue.500} 16%, transparent)',
                        borderColor: 'color-mix(in oklab, {blue.700} 36%, transparent)',
                        shadow: '0px 4px 8px 0px color-mix(in oklab, {blue.500} 4%, transparent)',
                        closeButton: {
                            hoverBackground: 'oklch(100% 0 0 / 5%)',
                        },
                    },
                    success: {
                        background: 'color-mix(in oklab, {green.500} 16%, transparent)',
                        borderColor: 'color-mix(in oklab, {green.700} 36%, transparent)',
                        shadow: '0px 4px 8px 0px color-mix(in oklab, {green.500} 4%, transparent)',
                    },
                    warn: {
                        background: 'color-mix(in oklab, {yellow.500} 16%, transparent)',
                        borderColor: 'color-mix(in oklab, {yellow.700} 36%, transparent)',
                        shadow: '0px 4px 8px 0px color-mix(in oklab, {yellow.500} 4%, transparent)',
                        closeButton: {
                            hoverBackground: 'oklch(100% 0 0 / 5%)',
                        },
                    },
                    error: {
                        background: 'color-mix(in oklab, {red.500} 16%, transparent)',
                        borderColor: 'color-mix(in oklab, {red.700} 36%, transparent)',
                        shadow: '0px 4px 8px 0px color-mix(in oklab, {red.500} 4%, transparent)',
                        closeButton: {
                            hoverBackground: 'oklch(100% 0 0 / 5%)',
                        },
                    },
                    secondary: {
                        shadow: '0px 4px 8px 0px color-mix(in oklab, {surface.500} 4%, transparent)',
                    },
                    contrast: {
                        shadow: '0px 4px 8px 0px color-mix(in oklab, {surface.950} 4%, transparent)',
                    },
                },
            },
        },
        togglebutton: {
            content: {
                checkedShadow: '0px 1px 2px 0px oklch(0% 0 0 / 2%), 0px 1px 2px 0px oklch(0% 0 0 / 4%)',
            },
        },
    },
});

export const MyPreset = definePreset(OklchAura, {
    semantic: {
        primary: {
            50: 'oklch(98.7% 0.021 99)',
            100: 'oklch(96.7% 0.056 99)',
            200: 'oklch(93.3% 0.109 99)',
            300: 'oklch(89% 0.154 95)',
            400: 'oklch(83.8% 0.17 88)',
            500: 'oklch(79.3% 0.166 77)',
            600: 'oklch(67.2% 0.152 66)',
            700: 'oklch(55.5% 0.134 57)',
            800: 'oklch(47.4% 0.113 53)',
            900: 'oklch(41.7% 0.093 51)',
            950: 'oklch(28.2% 0.064 49)',
        },
        secondary: {
            50: 'oklch(0.98 0 0)',
            100: 'oklch(0.94 0 0)',
            200: 'oklch(0.86 0 0)',
            300: 'oklch(0.74 0 0)',
            400: 'oklch(0.60 0 0)',
            500: 'oklch(0.46 0 0)',
            600: 'oklch(0.36 0 0)',
            700: 'oklch(0.27 0 0)',
            800: 'oklch(0.20 0 0)',
            900: 'oklch(0.14 0 0)',
            950: 'oklch(0.10 0 0)',
        },
        colorScheme: {
            // light: {
            //    ... (no secondary here)
            // },
            dark: {
                primary: {
                    contrastColor: '#FFFFFF',
                },
            },
        },
    },
} as any);
